module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1600.27dd7413.svg";